export const LAYER_MOVE_MODE = {
  REORDER: "REORDER",
  MOVE_INTO: "MOVE_INTO",
} as const;

export type LayerMoveMode =
  (typeof LAYER_MOVE_MODE)[keyof typeof LAYER_MOVE_MODE];
